import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSlangklem = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M22.44 14.06a7 7 0 0 1 7 6.46v-.57a7.044 7.044 0 1 0-14.09 0v.57a7 7 0 0 1 7.09-6.46M22.44 30a10.08 10.08 0 0 1-10.06-9.47v.61a10.09 10.09 0 0 0 20.17 0v-.61A10.08 10.08 0 0 1 22.44 30"
    />
    <path
      fill="#0061CD"
      d="M22.44 12.92A7.08 7.08 0 1 1 15.35 20a7.09 7.09 0 0 1 7.09-7.08m0-3a10.08 10.08 0 1 0 0 20.16 10.08 10.08 0 0 0 0-20.16"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M15.4 22.995a8.5 8.5 0 0 0 1.003 3.978l-2.646 1.414a11.5 11.5 0 0 1-1.357-5.382z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M8.89 15.5h5v10.68H7.48v-9.27a1.41 1.41 0 0 1 1.41-1.41M7.48 27.05a2.36 2.36 0 0 0 1.78 2.29v-1.1h1.19v1.1a2.36 2.36 0 0 0 1.78-2.29z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.241 11.143a10.3 10.3 0 0 1 3.595-2.155l.329.944a9.31 9.31 0 0 0-5.505 12.433l-.92.39a10.31 10.31 0 0 1 2.501-11.612"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSlangklem);

export default ForwardRef;
